import type { FC } from "react";
import { Fragment } from "react";
import { YStack } from "tamagui";

import { api } from "~/utils/api";
import { PersonGeneral } from "./person-general";
import { PersonResearch } from "./person-research";
import { PersonResearchTable } from "./person-research-table";

export interface PersonResultsProps {
  personId: string;
}
export const PersonResults: FC<PersonResultsProps> = ({ personId }) => {
  const [data] = api.personal.types.useSuspenseQuery({ personId });

  return (
    <YStack gap={"$6"}>
      <PersonGeneral personId={personId} />
      {data.map((item) => (
        <PersonResearch key={item.type} personId={personId} research={item}>
          {item.scaleGroups.map((group) => (
            <Fragment key={group.name}>
              {group.name && (
                <PersonResearchTable
                  personId={personId}
                  type={item.type}
                  group={"sphere"}
                  pdfDownload={false}
                  scales={group.scaleItems.filter(
                    (scale) => scale.name === group.name,
                  )}
                />
              )}
              <PersonResearchTable
                personId={personId}
                type={item.type}
                group={"scale"}
                scales={group.scaleItems.filter(
                  (scale) => scale.name !== group.name,
                )}
                pdfDownload={
                  group.name ? item.scaleGroups.at(-1) === group : true
                }
              />
            </Fragment>
          ))}
        </PersonResearch>
      ))}
    </YStack>
  );
};
